export const DeleteMessage = () => {
  return <></>;
};
